import { createI18n } from "vue-i18n";
import { WorkspaceLocale } from "@/constants/workplaces";
import en from "@/translations/en.json";
import es from "@/translations/es-ES.json";
import it from "@/translations/it-IT.json";
import fr from "@/translations/fr-FR.json";
import fr_ca from "@/translations/fr-CA.json";
import de from "@/translations/de-DE.json";
import pt_br from "@/translations/pt-BR.json";
import { en as vuetifyEnLocale } from "vuetify/locale";
import { es as vuetifyEsLocale } from "vuetify/locale";
import { it as vuetifyItLocale } from "vuetify/locale";
import { fr as vuetifyFrLocale } from "vuetify/locale";
import { de as vuetifyDeLocale } from "vuetify/locale";
import { pt as vuetifyPtLocale } from "vuetify/locale";

export type MessageSchema = typeof en;

export const i18n = createI18n<[MessageSchema], WorkspaceLocale, false>({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  locale: WorkspaceLocale.EN_US,
  fallbackLocale: WorkspaceLocale.EN_US,
  messages: {
    [WorkspaceLocale.EN_US]: { $vuetify: { ...vuetifyEnLocale }, ...en } as MessageSchema,
    [WorkspaceLocale.EN_GB]: { $vuetify: { ...vuetifyEnLocale }, ...en } as MessageSchema,
    [WorkspaceLocale.ES]: { $vuetify: { ...vuetifyEsLocale }, ...es } as MessageSchema,
    [WorkspaceLocale.IT]: { $vuetify: { ...vuetifyItLocale }, ...it } as MessageSchema,
    [WorkspaceLocale.FR]: { $vuetify: { ...vuetifyFrLocale }, ...fr } as MessageSchema,
    [WorkspaceLocale.FR_CA]: { $vuetify: { ...vuetifyFrLocale }, ...fr_ca } as MessageSchema,
    [WorkspaceLocale.DE]: { $vuetify: { ...vuetifyDeLocale }, ...de } as MessageSchema,
    [WorkspaceLocale.PT_BR]: { $vuetify: { ...vuetifyPtLocale }, ...pt_br } as MessageSchema,
  },
});
